/* Elemence Science — fetches the ingredients-orbit SVG, injects it into
   .elemence-science__orbit, then runs the molecule rotation animation.
   1:1 port of /3lemence_v7_2 anim-orbit.js logic. */
(function () {
  const CX = 429;
  const CY = 429;
  const SPEED_INNER  = 0.0013;
  const SPEED_MIDDLE = 0.00195;
  const SPEED_OUTER  = 0.0026;

  function runOrbit(rootEl) {
    const svg = rootEl.querySelector('svg');
    if (!svg) return () => {};
    svg.style.pointerEvents = 'none';

    const groups = Array.from(svg.querySelectorAll('g.molecule-group'));
    const molecules = groups.map((group) => {
      const rects = group.querySelectorAll('rect');
      const darkRect = rects[0];
      const strokeRect = rects.length > 1 ? rects[1] : null;
      const path = group.querySelector('path');
      if (!darkRect) return null;

      const origX = parseFloat(darkRect.getAttribute('data-original-x') || darkRect.getAttribute('x'));
      const origY = parseFloat(darkRect.getAttribute('data-original-y') || darkRect.getAttribute('y'));
      const w = parseFloat(darkRect.getAttribute('width'));
      const h = parseFloat(darkRect.getAttribute('height'));

      darkRect.setAttribute('x', origX);
      darkRect.setAttribute('y', origY);
      if (strokeRect) {
        strokeRect.setAttribute('x', origX);
        strokeRect.setAttribute('y', origY);
      }
      if (path) path.removeAttribute('transform');

      const cx = origX + w / 2;
      const cy = origY + h / 2;
      const dx = cx - CX;
      const dy = cy - CY;
      const radius = Math.hypot(dx, dy);

      return {
        group,
        origCx: cx,
        origCy: cy,
        radius,
        angle: Math.atan2(dy, dx),
        speed: radius < 200 ? SPEED_INNER : radius < 320 ? SPEED_MIDDLE : SPEED_OUTER,
      };
    }).filter(Boolean);

    let rafId = 0;
    let running = true;
    const step = () => {
      molecules.forEach((m) => {
        m.angle += m.speed;
        const tgtCx = CX + Math.cos(m.angle) * m.radius;
        const tgtCy = CY + Math.sin(m.angle) * m.radius;
        m.group.setAttribute('transform', `translate(${tgtCx - m.origCx}, ${tgtCy - m.origCy})`);
      });
      if (running) rafId = requestAnimationFrame(step);
    };
    step();
    return () => {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    };
  }

  function initHost(host) {
    if (!host || host.dataset.orbitInit === '1') return;
    const url = host.dataset.orbitSrc;
    if (!url) return;
    host.dataset.orbitInit = '1';
    fetch(url)
      .then((r) => r.text())
      .then((svgText) => {
        const tmp = document.createElement('div');
        tmp.innerHTML = svgText;
        const svgEl = tmp.querySelector('svg');
        if (!svgEl) return;
        host.innerHTML = '';
        host.appendChild(svgEl);
        runOrbit(host);
      })
      .catch(() => {});
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.elemence-science__orbit').forEach(initHost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
